import { paymentEnterpriseEligibilityUrl } from "./endpoints.js";
const paymentEnterpriseEligibilityCacheKey = ({
  accountId,
  accountIdType
}) => [paymentEnterpriseEligibilityUrl, { accountId, accountIdType }];
export {
  paymentEnterpriseEligibilityCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
